import styled, { css } from 'styled-components/macro';

export const Content = styled.div`
  ${({ theme }) => css`
    background: ${theme.light};
    width: 100%;
    margin: 0 auto;
    width: ${theme.breakpoints.sm}px;
    padding: 2rem;

    p {
      margin-bottom: 1rem;
    }
  `}
`;

export const Title = styled.p`
  font-weight: bold;
  text-align: center;
`;

export const WarningImage = styled.img`
  display: block;
  margin: 0 auto 1rem auto;
  height: 6rem;
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
`;
